import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import '@/plugins/noty/noty';
import App from '@/App';
import router from '@/router';
import store from '@/store/store';
import i18n from '@/plugins/i18n';
import firebase from '@/plugins/firebase';

import moment from 'moment';

moment.locale('pt-br');

new Vue({
  router,
  store,
  i18n,
  vuetify,
  provide: {
    firebase,
  },
  render: h => h(App)
}).$mount('#app');

/**
 * Import third party libs
 */
import '@/plugins/v-tooltip/v-tooltip';

/**
 * Sentry starts on any screen, but set user metadata in Layout.vue,
 * screen when user is already logged in.
 */
import '@/plugins/sentry';
import '@/plugins/logrocket';
import '@/plugins/analytics';
